import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormControl from '@material-ui/core/FormControl';

import { StyledHelperText } from 'styles/form';
import { ConstructionOutlined } from '@mui/icons-material';
import { subLocationNameGenerator } from 'helpers/site-name-generator';

const Component = styled.div``;

const AutoComplete = ({
  data,
  label,
  renderOption,
  setFieldValue,
  name,
  value,
  groupBy,
  getOptionLabel,
  selection,
  fullName,
  error,
  required,
  touched,
  bottom,
  subLocation,
  orgId,
  className,
}) => {
  const [inputValue, setInputValue] = useState('');
  const optionsData = data || [];

  const options = optionsData.map((option) => {
    const firstLetter = option[groupBy].charAt(0).toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  });

  const handleChange = (e, option) => {
    const onClear =
      e.target.className.baseVal === 'MuiSvgIcon-root MuiSvgIcon-fontSizeSmall';

    if (onClear || isEmpty(option)) {
      setFieldValue(name, '');
      setInputValue('');
    } else {
      setFieldValue(name, option.id);

      if (fullName) {
        setInputValue(`${option.first_name} ${option.last_name}`);
      } else if (subLocation) {
        setInputValue(subLocationNameGenerator(option));
      } else {
        setInputValue(option[groupBy]);
      }
    }
  };

  const handleValueChange = (e) => {
    if (e) {
      setInputValue(e.target.value);
    }
  };

  useEffect(() => {
    if (subLocation && !orgId) {
      setInputValue('');
    }
  }, [subLocation, orgId]);

  useEffect(() => {
    if (!isEmpty(selection)) {
      if (fullName) {
        setInputValue(`${selection.first_name} ${selection.last_name}`);
      } else if (subLocation) {
        setInputValue(subLocationNameGenerator(selection));
      } else {
        setInputValue(selection[groupBy]);
      }
    }
  }, [selection]);

  return (
    <Component className={className}>
      <FormControl fullWidth variant="outlined">
        <Autocomplete
          options={options.sort(
            (a, b) => -b.firstLetter.localeCompare(a.firstLetter),
          )}
          groupBy={(option) => option.firstLetter}
          getOptionLabel={getOptionLabel}
          fullWidth
          renderOption={renderOption}
          name={name}
          value={value}
          onChange={handleChange}
          inputValue={inputValue}
          onInputChange={handleValueChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              required={required}
              error={error}
            />
          )}
        />
        {error && touched && (
          <StyledHelperText error={error} bottom={bottom}>
            field is required
          </StyledHelperText>
        )}
      </FormControl>

      {/* <AddButton onClick={handleAdd}>+ Add {label}</AddButton> */}
    </Component>
  );
};

export default AutoComplete;
